import React, { useState } from "react";
import "./Register.css";
import GradientButton from "../../components/button/Button";
import { Logo } from "../../images/Images";
import axiosInstance from "../../axiosInstance";
import { toast } from "react-toastify";
import LoadingComponent from "../../components/loading/Loading";

const CreateBusinessComplete: React.FC = () => {
  const [loading, setLoading] = useState(false);
  // State for form inputs
  const [formData, setFormData] = useState({
    address_type: "billing",
    street: "",
    city: "",
    state: "",
    zip_code: "",
    country: "",
  });

  // Handle input change
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault(); // Prevent default form submission
    console.log("Payload:", formData); // Log the payload

    setLoading(true);

    try {
      const res: any = await axiosInstance.post("/address", formData);

      if (res.data) {
        setLoading(false);
        console.log("Response:", res.data); // Log the response

        // Show success message
        toast.success("Business address created successfully!");

        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 2000);
      }
    } catch (error: any) {
      setLoading(false);
      console.log(error.response.data);
    }
  };

  if (loading) {
    return <LoadingComponent />;
  }

  return (
    <div className="login-page">
      {/* Left-side Image */}
      <div className="login-page__image">
        <img
          src="https://img.freepik.com/free-photo/top-view-vegetables-fruits-zucchini-bell-peppers-apples-quince-cherry-tomatoes-cumcuat-parsley-cabbage-lemon-pomegranates_140725-59438.jpg?uid=R27806234&ga=GA1.1.1852762410.1725342281&semt=ais_hybrid"
          alt="Fresh Produce"
        />
      </div>

      {/* Right-side Form */}
      <div className="login-page__form-container">
        <form className="login-page__form" onSubmit={handleSubmit}>
          <div className="login-page__title">
            <img src={Logo} alt="logo" />
          </div>
          <h2 className="login-page__subtitle">Setup your Business Profile</h2>
          <p className="login-page__description">Let’s get started </p>

          {/* Input Fields */}
          <div className="login-page__input-group">
            <label>Street Address</label>
            <input
              type="text"
              name="street"
              placeholder="Enter your street address"
              value={formData.street}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="login-page__input-group">
            <label>City</label>
            <input
              type="text"
              name="city"
              placeholder="Enter your city"
              value={formData.city}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="login-page__input-group">
            <label>State/Province</label>
            <input
              type="text"
              name="state"
              placeholder="Enter your state or province"
              value={formData.state}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="login-page__input-group">
            <label>Postal Code</label>
            <input
              type="text"
              name="zip_code"
              placeholder="Enter your postal code"
              value={formData.zip_code}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="login-page__input-group">
            <label>Country</label>
            <input
              type="text"
              name="country"
              placeholder="Enter your country"
              value={formData.country}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="gd-btn">
            <GradientButton text="Sign Up" />
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateBusinessComplete;
